import {Component, OnInit, OnDestroy,ViewChild} from '@angular/core';
import {MessageService} from '../message.service';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Router} from '@angular/router';
import {Editors, Filters, Formatters} from 'angular-slickgrid';
import {NgbModal,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';

import {CustomInputEditor} from '../custom-inputEditor';
import { TOUCH_BUFFER_MS } from '@angular/cdk/a11y';

@Component({
  selector: 'app-support-user',
  templateUrl: './support-user.component.html',
  styleUrls: ['./support-user.component.css']
})
export class SupportUserComponent implements OnInit, OnDestroy {

  userSelected: string;
  groupSelected: number;
  show: boolean;
  dataset: any[];
  totalData: number;
  respObject: any;
  users = [];
  groups = [];
  userName: string;
  groupName: string;

  slideChecked = true;
  displayData: any;

  add = false;
  del = false;
  edit = false;
  view = false;

  isError = false;
  errorMessage: string;

  private notifier: NotifierService;
  private clientId: number;
  spocChecked = false;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private userAuth: Subscription;
  private baseFlag: any;
  offset: number;
  dataLoaded: boolean;
  isLoading = false;
    userId: number;
  searchUser: FormControl = new FormControl();
  showSearch = true;
  searchData: FormControl = new FormControl();
  userSelected1: any;
  usrs1 = [];
  userName1: string;
  showExportBtn = true;
  dataExcel = [];
  isExportDisable = false;

  @ViewChild('scarch_content') private scarch_content;
  private searchModalReference: NgbModalRef;




  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
              private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      switch (item.type) {
        case 'change':
          // console.log('changed');
          if (!this.messageService.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {

          }
          break;
        case 'delete':
          // console.log('deleted');
          if (!this.messageService.del) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
            if (confirm('Are you sure?')) {
              this._rest.deleteSupportGroupUserMapping({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                  // this.totalData = this.totalData - 1;
                  // this.messageService.setTotalData(this.totalData);
                  this.messageService.sendAfterDelete(item.id);
                } else {
                  this.notifier.notify('error', this.respObject.errorMessage);
                }
              }, (err) => {
                this.notifier.notify('error', this.respObject.errorMessage);
              });
            }
          }
          break;
      }
    });
    // this.messageService.getUserAuth().subscribe(details => {
    //   console.log(JSON.stringify(details));
    //   if (details.length > 0) {
    //     this.add = details[0].addFlag;
    //     this.del = details[0].deleteFlag;
    //     this.view = details[0].viewFlag;
    //     this.edit = details[0].editFlag;
    //   } else {
    //     this.add = true;
    //     this.del = true;
    //     this.view = true;
    //     this.edit = true;
    //   }
    // });
  }


  ngOnInit() {
    this.userName = '';
    this.dataLoaded = false;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.paginationType = 'next';
    this.displayData = {
      pageName: ' Maintain SupportGroup Mapping with User',
      openModalButton: 'Group User Map',
      searchModalButton: 'Search',
      breadcrumb: 'SupportGroupUserMap',
      folderName: 'All SupportGroup User Map',
      tabName: 'SupportGroup User Map',
      exportBtn: 'Export to excel'

    };
    const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},

      {
        id: 'group', name: 'Support Group ', field: 'groupname', sortable: true, filterable: true
      },
      {
        id: 'user', name: 'User ', field: 'user', sortable: true, filterable: true
      },
      {
        id: 'is_spoc', name: 'Team Lead', field: 'is_spoc', formatter: Formatters.checkmark,
        filter: {
          collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
          model: Filters.singleSelect,

          filterOptions: {
            autoDropWidth: true
          },
        }, sortable: true, filterable: true, minWidth: 40,cssClass: 'highlight', editor: {
          model: Editors.checkbox,
        }
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
        this.view = auth[0].viewFlag;
        this.add = auth[0].addFlag;
        this.edit = auth[0].editFlag;
        this.del = auth[0].deleteFlag;
        this.clientId = auth[0].clientId;
        this.baseFlag = auth[0].baseFlag;
        this.onPageLoad();
      });
    }

    this.searchUser.valueChanges.subscribe(
      psOrName => {
          this.isLoading = true;
        if (psOrName !== '') {
          this._rest.getUserWithOrWithoutVendorMapping(this.clientId, this.slideChecked, this.groupSelected, psOrName).subscribe((res1) => {
              this.respObject = res1;
              this.isLoading = false;
              if (this.respObject.success) {
                  this.users = this.respObject.details;
                  // console.log("true"+ JSON.stringify(this.users));
              } else {
                  this.notifier.notify('error', this.respObject.errorMessage);
              }
          }, (err) => {
              this.isLoading = false;
              this.notifier.notify('error', this.messageService.SERVER_ERROR);
          });
        } else {
          this.users = [];
          this.userName = '';
          this.isLoading = false;
        }
      });
  }

  onPageLoad() {
    this.slideChecked = false;
    this._rest.getUserdetails(this.messageService.getUserId()).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.clientId = this.respObject.details[0].clientId;
        this._rest.getSupportGroupByClientId(this.clientId).subscribe((res1) => {
          this.respObject = res1;
          if (this.respObject.success) {
            this.isError = false;
            this.respObject.details.unshift({id: 0, name: 'Select Support Group'});
            this.groups = this.respObject.details;
            this.groupSelected = 0;
          } else {
            this.isError = true;
            this.errorMessage = this.respObject.errorMessage;
          }
        }, (err) => {
          this.isError = true;
          this.errorMessage = this.messageService.SERVER_ERROR;
        });
        // this.getUsers();
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', JSON.stringify(err));
    });
    this.getTableData();
  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  // getUsers() {
  //   this._rest.getUserWithOrWithoutVendorMapping(this.clientId, this.slideChecked, this.groupSelected).subscribe((res1) => {
  //     this.respObject = res1;
  //     if (this.respObject.success) {
  //       console.log(JSON.stringify(this.respObject));
  //       this.isError = false;
  //       // this.respObject.details.unshift({id: 0, name: 'Select User'});
  //       this.users = this.respObject.details;
  //       // this.userSelected = 0;
  //     } else {
  //       this.isError = true;
  //       this.errorMessage = this.respObject.errorMessage;
  //     }
  //   }, (err) => {
  //     this.isError = true;
  //     this.errorMessage = this.messageService.SERVER_ERROR;
  //   });
  // }


  exportToExcel() {
    this.isExportDisable = true;

    // console.log("okkk" +this.clientId);
    this._rest.getAllMapUserWithSupportGroup(this.clientId).subscribe((res1) => {
        this.respObject = res1;
        if (this.respObject.success) {
            this.isExportDisable = false;

            this.dataExcel = this.respObject.details;
            // console.log('true' + JSON.stringify(this.dataExcel));
            this.messageService.exportAsExcelFile(this.dataExcel);
        } else {
            this.notifier.notify('error', this.respObject.errorMessage);
        }
    }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
}



  openModal(content) {
    if (!this.messageService.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.isError = false;
      this.userSelected = '';
      this.groupSelected = 0;
      this.modalService.open(content).result.then((result) => {
      }, (reason) => {
      });
    }
  }

  searchModal()  {
    if (!this.messageService.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.isError = false;
      this.userSelected = '';
      this.groupSelected = 0;
      this.searchModalReference = this.modalService.open(this.scarch_content);
      this.searchModalReference.result.then((result) => {
      }, (reason) => {

      });
}
  }

    getUserDetails() {
      for (let i = 0; i < this.users.length; i++) {
          if (this.users[i].login_name === this.userSelected) {
              this.userId = this.users[i].id;
              this.userName = this.users[i].name;
          }
      }
  }

  search() {
      this._rest.searchAllMapUserWithSupportGroup( this.userSelected1, this.clientId).subscribe((res1) => {
          this.respObject = res1;
          this.isLoading = false;
          if (this.respObject.success) {
              this.usrs1 = this.respObject.details;
              this.messageService.setTotalData(this.usrs1.length);
              this.messageService.setGridData(this.usrs1);
              this.searchModalReference.close();
          } else {
              this.notifier.notify('error', this.respObject.errorMessage);
          }
      }, (err) => {
          this.isLoading = false;
          this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
  }
  
  save() {
    const data = {
      clientId: this.clientId,
        refer_user_id: this.userId,
      groupId: this.groupSelected,
      createdBy: this.messageService.getUserId(),
      isSpoc: this.spocChecked
    };
    if (!this.messageService.isBlankField(data)) {
      this._rest.insertSupportGroupUserMapping(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.totalData = this.totalData + 1;
          this.messageService.setTotalData(this.totalData);
          this.isError = false;
          const id = this.respObject.id;
          this.messageService.setRow({id: id, groupname: this.groupName, user: this.userName});
          if (this.totalData <= this.pageSize * this.page_no) {
              this.offset = id;
              this.nextOffset = 0;
          } else {
              this.nextOffset = this.offset;
          }
          this.userSelected = '';
          this.groupSelected = 0;
          this.slideChecked = false;
          this.spocChecked = false;
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = this.messageService.SERVER_ERROR;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }

  getTableData() {
    if (!this.messageService.view) {
      this.notifier.notify('error', 'You do not have view permission');
    } else {
      this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  getData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this.dataLoaded = false;
    this._rest.getSupportGroupUserMapping(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
      this.respObject = res;
      this.executeResponse(this.respObject, offset, paginationType);
    }, (err) => {
      this.notifier.notify('error', JSON.stringify(err));
    });
  }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
          this.dataLoaded = true;

            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

  onGroupChange(selectedIndex: any) {
    this.groupName = this.groups[selectedIndex].name;
    // this.getUsers();
  }

  slideChange() {
    this.slideChecked = !this.slideChecked;
    // this.getUsers();
  }

  spocChange() {
    this.spocChecked = !this.spocChecked;
  }

  onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }

  ngOnDestroy(): void {
    if (this.userAuth) {
      this.userAuth.unsubscribe();
    }
  }
}
